module.exports = __webpack_public_path__ + "img/block-card-desc-bg.edbe526d.png";